// Import model
import { StartLeadAppointmentSendUpcomingAppointmentReminderRequest } from '../models/StartLeadAppointmentSendUpcomingAppointmentReminderRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartLeadAppointmentSendUpcomingAppointmentReminderRequest - handles JSON serialization and deserialization with type validation
 */
export class StartLeadAppointmentSendUpcomingAppointmentReminderRequestSerializer {
  /**
   * Deserializes a JSON string into a StartLeadAppointmentSendUpcomingAppointmentReminderRequest instance
   */
  static deserialize(json: string): StartLeadAppointmentSendUpcomingAppointmentReminderRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartLeadAppointmentSendUpcomingAppointmentReminderRequest instance
   */
  static fromObject(obj: any): StartLeadAppointmentSendUpcomingAppointmentReminderRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartLeadAppointmentSendUpcomingAppointmentReminderRequest');
    }


    const instance: StartLeadAppointmentSendUpcomingAppointmentReminderRequest = {
      phoneNumber: obj['PhoneNumber'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartLeadAppointmentSendUpcomingAppointmentReminderRequest instances
   */
  static deserializeArray(json: string): StartLeadAppointmentSendUpcomingAppointmentReminderRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartLeadAppointmentSendUpcomingAppointmentReminderRequest instance to a JSON string
   */
  static serialize(instance: StartLeadAppointmentSendUpcomingAppointmentReminderRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartLeadAppointmentSendUpcomingAppointmentReminderRequest instance to a plain object
   */
  static toObject(instance: StartLeadAppointmentSendUpcomingAppointmentReminderRequest): any {
    return {
      'PhoneNumber': instance.phoneNumber,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartLeadAppointmentSendUpcomingAppointmentReminderRequest instances to a JSON string
   */
  static serializeArray(instances: StartLeadAppointmentSendUpcomingAppointmentReminderRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
